export default (theme) => {
  return `
    .mu-bottom-sheet {
      background-color: ${theme.background.paper};
    }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/BottomSheet/theme.js